import { Component, OnInit } from '@angular/core';
import { AdminContactModel } from "./admincontact.model";
import { AdminContactService } from "./admincontact.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { AdminConst } from '../const';
import { AdminContactImportComponent } from './admincontact-import.component';

@Component({
    selector: 'convfact-admincontact-list',
    templateUrl: './admincontact-list.component.html',
    styleUrls: ['./admincontact.component.css'],
    standalone: false
})

export class AdminContactListComponent implements OnInit {

  constructor(
    private admincontactService: AdminContactService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    public userCompanyService: UserCompanyService
  ) { }

  dataSource: AdminContactModel[];
  empty = false;
  ready = false;

  headerTable: any[] = AdminConst.headerTableContacts;

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  import() {
    this.dialog.open(AdminContactImportComponent, {
      height: '500px'
    });
  }

  ngOnInit() {
    this.admincontactService.getList().then(
      data => {
        this.dataSource = data;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      }
    );
  }
}
